import { render, staticRenderFns } from "./ScoreArea.vue?vue&type=template&id=0b5608f3&scoped=true&"
import script from "./ScoreArea.vue?vue&type=script&lang=js&"
export * from "./ScoreArea.vue?vue&type=script&lang=js&"
import style0 from "./ScoreArea.vue?vue&type=style&index=0&id=0b5608f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5608f3",
  null
  
)

export default component.exports